import { render, staticRenderFns } from "./baseInfoPart.vue?vue&type=template&id=84d79a40&scoped=true"
import script from "./baseInfoPart.vue?vue&type=script&lang=js"
export * from "./baseInfoPart.vue?vue&type=script&lang=js"
import style0 from "./baseInfoPart.vue?vue&type=style&index=0&id=84d79a40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84d79a40",
  null
  
)

export default component.exports